import type { IconProps } from './types';
import './icons.css';

export default function AlternativeSandWatch({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-app-logo ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M19.25 2.75a1 1 0 1 1 0 2v.75a7.244 7.244 0 0 1-4.046 6.5 7.244 7.244 0 0 1 4.046 6.5v.75a1 1 0 1 1 0 2H4.75a1 1 0 0 1 0-2v-.75A7.244 7.244 0 0 1 8.796 12 7.244 7.244 0 0 1 4.75 5.5v-.75a1 1 0 0 1 0-2h14.5ZM6.75 5.5a5.25 5.25 0 0 0 3.78 5.037c.427.124.72.516.72.96v1.006a1 1 0 0 1-.72.96A5.25 5.25 0 0 0 6.75 18.5v.75h1.635a3.752 3.752 0 0 1 7.23 0h1.635v-.75a5.25 5.25 0 0 0-3.78-5.037 1 1 0 0 1-.72-.96v-1.005c0-.445.293-.837.72-.961A5.25 5.25 0 0 0 17.25 5.5v-.75H6.75v.75ZM14 8a2 2 0 0 1-4 0h4Z"
      />
    </svg>
  );
}
